import { httpClient } from "../http-client/base-client";
import { ApiProducts } from "../types/products/api-types";

export const ProductsResource = {
  async getProducts(): Promise<ApiProducts[]> {
    const order = await httpClient.get<ApiProducts[]>("products");
    return order;
  },
};
